import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "./firebase";

const listingsRef = collection(db, "listings");

export function subscribeToActiveListings(callback) {
  const q = query(listingsRef, where("status", "==", "active"), orderBy("createdAt", "desc"));
  return onSnapshot(q, (snap) => {
    callback(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  });
}

// Recently sold listings, kept browsable (separate from subscribeToActiveListings,
// which Wishlist match alerts rely on staying strictly "available to buy") so a
// buyer can still find and rate a listing after the seller marks it sold.
export function subscribeToSoldListings(callback) {
  const q = query(listingsRef, where("status", "==", "sold"), orderBy("createdAt", "desc"));
  return onSnapshot(q, (snap) => {
    callback(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  });
}

export function subscribeToMyListings(sellerUserId, callback) {
  const q = query(listingsRef, where("sellerUserId", "==", sellerUserId), orderBy("createdAt", "desc"));
  return onSnapshot(q, (snap) => {
    callback(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  });
}

export function createListing(sellerUserId, data) {
  return addDoc(listingsRef, {
    ...data,
    sellerUserId,
    status: "active",
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
}

export function updateListing(listingId, data) {
  return updateDoc(doc(db, "listings", listingId), {
    ...data,
    updatedAt: serverTimestamp(),
  });
}

export function markListingSold(listingId) {
  return updateListing(listingId, { status: "sold" });
}

export function reactivateListing(listingId) {
  return updateListing(listingId, { status: "active" });
}

export function deleteListing(listingId) {
  return deleteDoc(doc(db, "listings", listingId));
}
